<template>
  <div class="grid-view">
    <div class="main-content accounting-entry-rule">
      <div class="section operations">
        <div class="filters">
          <span v-if="!locked">
            <el-button type="primary" @click="saveHandler">{{ $t('common.btn.save') }}</el-button>
            <el-button type="primary" @click="cancelHandler">{{ $t('common.btn.cancel') }}</el-button>
          </span>
          <span v-else>
            <el-button type="primary" @click="addHandler">{{ $t('common.btn.new') }}</el-button>
            <el-button :disabled="!selectedRow" type="primary" @click="editHandler">{{ $t('common.btn.edit') }}</el-button>
            <el-button type="primary" @click="refreshHandler">{{ $t('common.btn.refresh') }}</el-button>
            <el-button :disabled="!selectedRow" type="danger" @click="removeHandler">{{ $t('common.btn.delete') }}</el-button>
          </span>
        </div>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="min-height: 500px"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FinanceUtil from '@/utils/FinanceUtil'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import * as FinanceInterfaceConstants from '@/class/cargo/model/parameters/FinanceInterfaceConstants'
import { getLoading } from '@/utils/utilBaseElement'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as accountingEntryRuleApi from '@/api/financeManage/accountingEntryRule'
import * as accountingDocumentsRuleApi from '@/api/financeManage/accountingDocumentsRule'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'EntryGrouppingRule',
  props: {
    accountSet: { type: Object, default: null }
  },
  data() {
    return {
      selectedRow: null, // 是否选中行
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        // 单击显示编辑
        singleClickEdit: true,
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridSelectEditor,
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridCommonInputEditor
        },
        onRowClicked: this.onRowClickedHandler
      },
      rowData: [],
      locked: true,
      accountingDocumentsRules: [],
      accountingDocumentsRuleOptions: [],
      entryTypeDataProvider: [],
      enableAccountingEntryOrder: false,
      customJobTypeAvailableRuleKeys: [], // 自定义业务类型可用的规则
      cargoCategoryAvailableRuleKeys: [] // 货物大类可用的规则
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_VoucherGroupingType'),
          field: 'accountingDocumentRuleUuid',
          width: 120,
          editable: this.editableHandler,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            tagName: 'name',
            tagValue: 'uuid',
            options: this.accountingDocumentsRuleOptions
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
            this.bizTypeChangeHandler(params.node.data)
          },
          valueFormatter: params => {
            const op = this.accountingDocumentsRuleOptions.find(rule => rule.uuid === params.node.data.accountingDocumentRuleUuid)
            return op ? op.name : ''
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          field: 'sequenceNo',
          width: 75,
          editable: this.editableHandler,
          sortable: false,
          hide: !this.enableAccountingEntryOrder,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 0,
              min: 1,
              max: 100,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DataType'),
          field: 'entryType',
          width: 130,
          editable: this.editableHandler,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: this.entryTypeDataProvider,
              tagName: this.$store.getters.isZh ? 'chineseName' : 'englishName',
              tagValue: 'code',
              filterable: false,
              clearable: true
            }
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          valueFormatter: params => {
            return FinanceUtil.entryTypeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AccountTitleClassification'),
          field: 'entrySeries',
          width: 100,
          hide: true,
          lockVisible: true,
          editable: this.editableHandler,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 0,
              max: 7,
              min: 1,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AccountTitleGroupingCondition1'),
          field: 'groupingDimension1',
          width: 130,
          editable: this.editableHandler,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              // staticOptions: Array.from(FinanceInterfaceConstants.ENTRY_GROUPING_DIMENSIONS),
              tagName: this.$store.getters.isZh ? 'chineseName' : 'englishName',
              tagValue: 'code',
              filterable: true,
              clearable: true
            },
            getStaticOptions: data => {
              return Array.from(FinanceInterfaceConstants.ENTRY_GROUPING_DIMENSIONS).filter(p => {
                if (p.code === FinanceInterfaceConstants.DIMENSION_CUSTOM_JOB_TYPE.code) {
                  return this.customJobTypeAvailableRuleKeys.includes(data.accountingDocumentRuleUuid)
                }
                if (p.code === FinanceInterfaceConstants.DIMENSION_CARGO_CATEGORY.code) {
                  return this.cargoCategoryAvailableRuleKeys.includes(data.accountingDocumentRuleUuid)
                }
                return true
              })
            }
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          valueFormatter: params => {
            return FinanceUtil.entryGroupingDimensionLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AccountTitleGroupingCondition2'),
          field: 'groupingDimension2',
          width: 130,
          editable: this.editableHandler,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              // staticOptions: Array.from(FinanceInterfaceConstants.ENTRY_GROUPING_DIMENSIONS),
              tagName: this.$store.getters.isZh ? 'chineseName' : 'englishName',
              tagValue: 'code',
              filterable: true,
              clearable: true
            },
            getStaticOptions: data => {
              return Array.from(FinanceInterfaceConstants.ENTRY_GROUPING_DIMENSIONS).filter(p => {
                if (p.code === FinanceInterfaceConstants.DIMENSION_CUSTOM_JOB_TYPE.code) {
                  return this.customJobTypeAvailableRuleKeys.includes(data.accountingDocumentRuleUuid)
                }
                if (p.code === FinanceInterfaceConstants.DIMENSION_CARGO_CATEGORY.code) {
                  return this.cargoCategoryAvailableRuleKeys.includes(data.accountingDocumentRuleUuid)
                }
                return true
              })
            }
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          valueFormatter: params => {
            return FinanceUtil.entryGroupingDimensionLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AccountTitleGroupingCondition3'),
          field: 'groupingDimension3',
          width: 130,
          editable: this.editableHandler,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              // staticOptions: Array.from(FinanceInterfaceConstants.ENTRY_GROUPING_DIMENSIONS),
              tagName: this.$store.getters.isZh ? 'chineseName' : 'englishName',
              tagValue: 'code',
              filterable: true,
              clearable: true
            },
            getStaticOptions: data => {
              return Array.from(FinanceInterfaceConstants.ENTRY_GROUPING_DIMENSIONS).filter(p => {
                if (p.code === FinanceInterfaceConstants.DIMENSION_CUSTOM_JOB_TYPE.code) {
                  return this.customJobTypeAvailableRuleKeys.includes(data.accountingDocumentRuleUuid)
                }
                if (p.code === FinanceInterfaceConstants.DIMENSION_CARGO_CATEGORY.code) {
                  return this.cargoCategoryAvailableRuleKeys.includes(data.accountingDocumentRuleUuid)
                }
                return true
              })
            }
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          valueFormatter: params => {
            return FinanceUtil.entryGroupingDimensionLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AccountTitleGroupingCondition4'),
          field: 'groupingDimension4',
          width: 130,
          editable: this.editableHandler,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              // staticOptions: Array.from(FinanceInterfaceConstants.ENTRY_GROUPING_DIMENSIONS),
              tagName: this.$store.getters.isZh ? 'chineseName' : 'englishName',
              tagValue: 'code',
              filterable: true,
              clearable: true
            },
            getStaticOptions: data => {
              return Array.from(FinanceInterfaceConstants.ENTRY_GROUPING_DIMENSIONS).filter(p => {
                if (p.code === FinanceInterfaceConstants.DIMENSION_CUSTOM_JOB_TYPE.code) {
                  return this.customJobTypeAvailableRuleKeys.includes(data.accountingDocumentRuleUuid)
                }
                if (p.code === FinanceInterfaceConstants.DIMENSION_CARGO_CATEGORY.code) {
                  return this.cargoCategoryAvailableRuleKeys.includes(data.accountingDocumentRuleUuid)
                }
                return true
              })
            }
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          valueFormatter: params => {
            return FinanceUtil.entryGroupingDimensionLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AccountTitleGroupingCondition5'),
          field: 'groupingDimension5',
          width: 130,
          editable: this.editableHandler,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              // staticOptions: Array.from(FinanceInterfaceConstants.ENTRY_GROUPING_DIMENSIONS),
              tagName: this.$store.getters.isZh ? 'chineseName' : 'englishName',
              tagValue: 'code',
              filterable: true,
              clearable: true
            },
            getStaticOptions: data => {
              return Array.from(FinanceInterfaceConstants.ENTRY_GROUPING_DIMENSIONS).filter(p => {
                if (p.code === FinanceInterfaceConstants.DIMENSION_CUSTOM_JOB_TYPE.code) {
                  return this.customJobTypeAvailableRuleKeys.includes(data.accountingDocumentRuleUuid)
                }
                if (p.code === FinanceInterfaceConstants.DIMENSION_CARGO_CATEGORY.code) {
                  return this.cargoCategoryAvailableRuleKeys.includes(data.accountingDocumentRuleUuid)
                }
                return true
              })
            }
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          valueFormatter: params => {
            return FinanceUtil.entryGroupingDimensionLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AccountTitleGroupingCondition6'),
          field: 'groupingDimension6',
          width: 130,
          editable: this.editableHandler,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              // staticOptions: Array.from(FinanceInterfaceConstants.ENTRY_GROUPING_DIMENSIONS),
              tagName: this.$store.getters.isZh ? 'chineseName' : 'englishName',
              tagValue: 'code',
              filterable: true,
              clearable: true
            },
            getStaticOptions: data => {
              return Array.from(FinanceInterfaceConstants.ENTRY_GROUPING_DIMENSIONS).filter(p => {
                if (p.code === FinanceInterfaceConstants.DIMENSION_CUSTOM_JOB_TYPE.code) {
                  return this.customJobTypeAvailableRuleKeys.includes(data.accountingDocumentRuleUuid)
                }
                if (p.code === FinanceInterfaceConstants.DIMENSION_CARGO_CATEGORY.code) {
                  return this.cargoCategoryAvailableRuleKeys.includes(data.accountingDocumentRuleUuid)
                }
                return true
              })
            }
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          valueFormatter: params => {
            return FinanceUtil.entryGroupingDimensionLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SubsidiaryAccountingCondition1'),
          field: 'auxiliaryGrouping1',
          width: 130,
          editable: this.editableHandler,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              // staticOptions: Array.from(FinanceInterfaceConstants.ENTRY_GROUPING_DIMENSIONS),
              tagName: this.$store.getters.isZh ? 'chineseName' : 'englishName',
              tagValue: 'code',
              filterable: true,
              clearable: true
            },
            getStaticOptions: data => {
              return Array.from(FinanceInterfaceConstants.ENTRY_GROUPING_DIMENSIONS).filter(p => {
                if (p.code === FinanceInterfaceConstants.DIMENSION_CUSTOM_JOB_TYPE.code) {
                  return this.customJobTypeAvailableRuleKeys.includes(data.accountingDocumentRuleUuid)
                }
                if (p.code === FinanceInterfaceConstants.DIMENSION_CARGO_CATEGORY.code) {
                  return this.cargoCategoryAvailableRuleKeys.includes(data.accountingDocumentRuleUuid)
                }
                return true
              })
            }
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          valueFormatter: params => {
            return FinanceUtil.entryGroupingDimensionLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SubsidiaryAccountingCondition2'),
          field: 'auxiliaryGrouping2',
          width: 130,
          editable: this.editableHandler,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              // staticOptions: Array.from(FinanceInterfaceConstants.ENTRY_GROUPING_DIMENSIONS),
              tagName: this.$store.getters.isZh ? 'chineseName' : 'englishName',
              tagValue: 'code',
              filterable: true,
              clearable: true
            },
            getStaticOptions: data => {
              return Array.from(FinanceInterfaceConstants.ENTRY_GROUPING_DIMENSIONS).filter(p => {
                if (p.code === FinanceInterfaceConstants.DIMENSION_CUSTOM_JOB_TYPE.code) {
                  return this.customJobTypeAvailableRuleKeys.includes(data.accountingDocumentRuleUuid)
                }
                if (p.code === FinanceInterfaceConstants.DIMENSION_CARGO_CATEGORY.code) {
                  return this.cargoCategoryAvailableRuleKeys.includes(data.accountingDocumentRuleUuid)
                }
                return true
              })
            }
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          valueFormatter: params => {
            return FinanceUtil.entryGroupingDimensionLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SubsidiaryAccountingCondition3'),
          field: 'auxiliaryGrouping3',
          width: 130,
          editable: this.editableHandler,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              // staticOptions: Array.from(FinanceInterfaceConstants.ENTRY_GROUPING_DIMENSIONS),
              tagName: this.$store.getters.isZh ? 'chineseName' : 'englishName',
              tagValue: 'code',
              filterable: true,
              clearable: true
            },
            getStaticOptions: data => {
              return Array.from(FinanceInterfaceConstants.ENTRY_GROUPING_DIMENSIONS).filter(p => {
                if (p.code === FinanceInterfaceConstants.DIMENSION_CUSTOM_JOB_TYPE.code) {
                  return this.customJobTypeAvailableRuleKeys.includes(data.accountingDocumentRuleUuid)
                }
                if (p.code === FinanceInterfaceConstants.DIMENSION_CARGO_CATEGORY.code) {
                  return this.cargoCategoryAvailableRuleKeys.includes(data.accountingDocumentRuleUuid)
                }
                return true
              })
            }
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          valueFormatter: params => {
            return FinanceUtil.entryGroupingDimensionLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SubsidiaryAccountingCondition4'),
          field: 'auxiliaryGrouping4',
          width: 130,
          editable: this.editableHandler,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              // staticOptions: Array.from(FinanceInterfaceConstants.ENTRY_GROUPING_DIMENSIONS),
              tagName: this.$store.getters.isZh ? 'chineseName' : 'englishName',
              tagValue: 'code',
              filterable: true,
              clearable: true
            },
            getStaticOptions: data => {
              return Array.from(FinanceInterfaceConstants.ENTRY_GROUPING_DIMENSIONS).filter(p => {
                if (p.code === FinanceInterfaceConstants.DIMENSION_CUSTOM_JOB_TYPE.code) {
                  return this.customJobTypeAvailableRuleKeys.includes(data.accountingDocumentRuleUuid)
                }
                if (p.code === FinanceInterfaceConstants.DIMENSION_CARGO_CATEGORY.code) {
                  return this.cargoCategoryAvailableRuleKeys.includes(data.accountingDocumentRuleUuid)
                }
                return true
              })
            }
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          valueFormatter: params => {
            return FinanceUtil.entryGroupingDimensionLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SubsidiaryAccountingCondition5'),
          field: 'auxiliaryGrouping5',
          width: 130,
          editable: this.editableHandler,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              // staticOptions: Array.from(FinanceInterfaceConstants.ENTRY_GROUPING_DIMENSIONS),
              tagName: this.$store.getters.isZh ? 'chineseName' : 'englishName',
              tagValue: 'code',
              filterable: true,
              clearable: true
            },
            getStaticOptions: data => {
              return Array.from(FinanceInterfaceConstants.ENTRY_GROUPING_DIMENSIONS).filter(p => {
                if (p.code === FinanceInterfaceConstants.DIMENSION_CUSTOM_JOB_TYPE.code) {
                  return this.customJobTypeAvailableRuleKeys.includes(data.accountingDocumentRuleUuid)
                }
                if (p.code === FinanceInterfaceConstants.DIMENSION_CARGO_CATEGORY.code) {
                  return this.cargoCategoryAvailableRuleKeys.includes(data.accountingDocumentRuleUuid)
                }
                return true
              })
            }
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          valueFormatter: params => {
            return FinanceUtil.entryGroupingDimensionLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SubsidiaryAccountingCondition6'),
          field: 'auxiliaryGrouping6',
          width: 130,
          editable: this.editableHandler,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              // staticOptions: Array.from(FinanceInterfaceConstants.ENTRY_GROUPING_DIMENSIONS),
              tagName: this.$store.getters.isZh ? 'chineseName' : 'englishName',
              tagValue: 'code',
              filterable: true,
              clearable: true
            },
            getStaticOptions: data => {
              return Array.from(FinanceInterfaceConstants.ENTRY_GROUPING_DIMENSIONS).filter(p => {
                if (p.code === FinanceInterfaceConstants.DIMENSION_CUSTOM_JOB_TYPE.code) {
                  return this.customJobTypeAvailableRuleKeys.includes(data.accountingDocumentRuleUuid)
                }
                if (p.code === FinanceInterfaceConstants.DIMENSION_CARGO_CATEGORY.code) {
                  return this.cargoCategoryAvailableRuleKeys.includes(data.accountingDocumentRuleUuid)
                }
                return true
              })
            }
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          valueFormatter: params => {
            return FinanceUtil.entryGroupingDimensionLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FixedAccountingCode'),
          field: 'accountingCode',
          width: 130,
          hide: true,
          lockVisible: true,
          editable: this.editableHandler,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            inputProps: {
              style: 'width: 100%'
            }
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_NeedToExportOrNot'),
          field: 'needExport',
          width: 130,
          editable: this.editableHandler,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            tagName: 'name',
            tagValue: 'code',
            options: [{ name: this.$t('FinanceManage.NeedToExport'), code: true }, { name: this.$t('FinanceManage.NoExportNeeded'), code: false }]
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          valueFormatter: params => {
            return params.value ? '√' : ''
          }
        }
      ]
    },
    accountSetUuid() {
      return this.accountSet.uuid
    }
  },
  watch: {
    locked(val) {
      this.gridOptions.columnApi.setColumnVisible('entrySeries', !val)
      this.gridOptions.columnApi.setColumnVisible('accountingCode', !val)
    },
    accountSetUuid() {
      this.loadAccountingDocumentsRules()
      this.loadRules()
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.enableAccountingEntryOrder = Number(cache.config.get('enableAccountingEntryOrder')) === 1
    await this.loadAccountingDocumentsRules()
    // 加载列表
    this.loadRules()
  },
  methods: {
    async loadAccountingDocumentsRules() {
      const accountingDocumentsRules = this.accountSet.accountingDocumentsRule // await accountingDocumentsRuleApi.query({ accountSetUuid: this.accountSet.uuid }).then(resp => resp.data.list)
      const arr = []
      // 自定义业务类型可用的凭证分组类型
      const customJobTypeAvailableDataTypes = [
        FinanceInterfaceConstants.BIZ_REVENUE.code,
        FinanceInterfaceConstants.BIZ_COST.code,
        FinanceInterfaceConstants.BIZ_COST_REVENUE.code,
        FinanceInterfaceConstants.INVOICE_RECEIVABLE.code,
        FinanceInterfaceConstants.INVOICE_PAYABLE.code,
        FinanceInterfaceConstants.INVOICE_RECEIVABLE_PAYABLE.code,
        FinanceInterfaceConstants.BILLING_RECEIVABLE.code,
        FinanceInterfaceConstants.BILLING_PAYABLE.code,
        FinanceInterfaceConstants.BILLING_OVERSEA.code,
        FinanceInterfaceConstants.RECEIPT_INTERNAL.code,
        FinanceInterfaceConstants.PAYMENT_INTERNAL.code,
        FinanceInterfaceConstants.RECEIPT_FOREGIN.code,
        FinanceInterfaceConstants.PAYMENT_FOREGIN.code,
        FinanceInterfaceConstants.RECEIPT_PAYMENT.code,
        FinanceInterfaceConstants.BILLPAYMENT.code,
        FinanceInterfaceConstants.PRE_RECEIPT_PAYMENT_CLEAR.code,
        FinanceInterfaceConstants.RECEIPT_PAYMENT_OFFSET.code,
        FinanceInterfaceConstants.INVOICE_PAYABLE_OFFSET.code
      ]
      // 自定义业务类型可用的规则
      const customJobTypeAvailableRuleKeys = []
      for (const rule of accountingDocumentsRules) {
        const el = {}
        el.uuid = rule.uuid
        el.name = this.bizTypeDDLLabelFun(rule)
        arr.push(el)
        if (customJobTypeAvailableDataTypes.includes(rule.businessDataType)) {
          customJobTypeAvailableRuleKeys.push(rule.uuid)
        }
      }
      this.accountingDocumentsRules = accountingDocumentsRules
      this.accountingDocumentsRuleOptions = arr
      this.customJobTypeAvailableRuleKeys = customJobTypeAvailableRuleKeys
      // 货物大类可用的规则和自定义业务类型一样
      this.cargoCategoryAvailableRuleKeys = this.customJobTypeAvailableRuleKeys
    },
    loadRules() {
      const loading = getLoading()
      const params = {}
      params.accountSetUuid = this.accountSet.uuid
      accountingEntryRuleApi.query(params).then(resp => {
        this.setDefaultValue(resp.data.list)
        this.rowData = resp.data.list
        this.gridOptions.api.refreshCells({ force: true })
      }).catch(() => {
        this.rowData = []
        this.gridOptions.api.refreshCells({ force: true })
      }).finally(() => loading.close())
      this.gridOptions.api.clearFocusedCell()
      this.selectedRow = null
    },
    addHandler() {
      this.locked = false
      const rule = {}
      rule.accountSetUuid = this.accountSet.uuid
      rule.needExport = true
      rule.waitDealStatus = 'add'
      this.rowData.push(rule)
      this.gridOptions.api.refreshCells({ force: true })
    },
    editHandler() {
      if (this.rowData && this.rowData.length > 0) {
        this.locked = false
      }
    },
    saveHandler() {
      const saveList = []
      for (const rule of this.rowData) {
        if (['add', 'edit'].includes(rule.waitDealStatus)) {
          saveList.push(rule)
        }
      }
      if (saveList.length) {
        // 校验
        for (const rule of saveList) {
          if (!rule.accountingDocumentRuleUuid) {
            this.$message.warning(this.$t('CargoMsg.Cargo_PSDTOVG'))
            return
          } else if (Number(rule.entryType) === -1) {
            this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectDataType'))
            return
          } else if (this.getDimensionCount(rule) !== Number(rule.entrySeries) - 1) {
            this.$message.warning(this.$t('CargoMsg.Cargo_NOATGCAAIODMBETTGMO'))
            return
          }
        }
        // 保存
        const loading = getLoading('app-main-content')
        accountingEntryRuleApi.save(saveList).then(resp => {
          this.saveSuccess(resp)
          this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        }).finally(() => loading.close())
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoDataModifiedNoNeedToSave'))
      }
      this.locked = true
    },
    getDimensionCount(rule) {
      let count = 0
      for (let i = 1; i <= 6; i++) {
        if (rule['groupingDimension' + i]) {
          count++
        }
      }
      return count
    },
    cancelHandler() {
      this.locked = true
      this.loadRules()
    },
    refreshHandler() {
      this.loadRules()
      this.loadAccountingDocumentsRules()
    },
    async removeHandler() {
      const cell = this.gridOptions.api.getFocusedCell()
      // const currentRow = cell ? this.rowData[cell.rowIndex] : null
      const currentRow = cell ? this.selectedRow : null
      if (!currentRow) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      await this.$confirm(this.$t('CargoMsg.Cargo_SureToDeleteTheRule'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        canCloseModule: true
      })
      const loading = getLoading()
      accountingEntryRuleApi.remove({ uuid: currentRow.uuid }).then(resp => {
        this.removeSuccess(currentRow.uuid)
      }).finally(() => loading.close())
    },
    onCellChange(params) {
      const { node } = params
      if (node.data.uuid) {
        node.data.waitDealStatus = 'edit'
      }
    },
    saveSuccess(resp) {
      this.setDefaultValue(resp.data)
      // 返回的列表中可能同时含有编辑的和新增的数据
      const list = resp.data
      if (!list || list.length === 0) return
      // 1 遍历rowData列表能匹配到uuid的数据（编辑的数据），更新数据
      for (let i = 0; i < this.rowData.length; i++) {
        const row = this.rowData[i]
        if (row.uuid) {
          const index = list.findIndex(params => params.uuid === row.uuid)
          if (index > -1) {
            Object.assign(row, list[index])
            list.splice(index, 1)
          }
          row.waitDealStatus = ''
        }
      }
      // 2 遍历rowData列表中没有uuid的数据 删除该数据
      for (let i = this.rowData.length - 1; i >= 0; i--) {
        if (!this.rowData[i].uuid) {
          this.rowData.splice(i, 1)
        }
      }
      // 3 添加列表里没有匹配uuid的数据（新增的数据）到列表
      this.rowData.push(...list)
      this.gridOptions.api.refreshCells({ force: true })
    },
    removeSuccess(uuid) {
      const index = this.rowData.findIndex(params => params.uuid === uuid)
      if (index > -1) {
        this.rowData.splice(index, 1)
        this.gridOptions.api.refreshCells({ force: true })
      }
      this.$message.success(this.$t('Message.DeleteSuccessfully'))
    },
    bizTypeDDLLabelFun(rule) {
      const state = CommonState.getStateByCode(FinanceInterfaceConstants.BIZ_DATA_TYPES, rule.businessDataType)
      let label = state == null ? '' : this.$getLangColumn(state)
      if (label && rule.accountingMode && rule.accountingMode === FinanceInterfaceConstants.MODE_HEDGE.code) {
        label += '(' + FinanceInterfaceConstants.MODE_HEDGE.label + ')'
      }
      return label
    },
    bizTypeChangeHandler(rule) {
      if (rule.accountingDocumentRuleUuid) {
        const docRule = this.accountingDocumentsRules.find(params => params.uuid === rule.accountingDocumentRuleUuid)
        let key = docRule.businessDataType.toString()
        if (Number(docRule.accountingMode) === FinanceInterfaceConstants.MODE_HEDGE.code) {
          key += '#'
        }
        this.entryTypeDataProvider = Array.from(FinanceInterfaceConstants.MAPPING[key])
      } else {
        this.entryTypeDataProvider = []
      }
    },
    editableHandler(event) {
      console.log(event.data === this.selectedRow)
      return !this.locked && event.data === this.selectedRow
    },
    onRowClickedHandler(event) {
      this.selectedRow = event.data
      this.bizTypeChangeHandler(this.selectedRow)
    },
    setDefaultValue(ruleList) {
      if (ruleList) {
        for (const rule of ruleList) {
          if (rule.auxiliaryGrouping1 === 0) rule.auxiliaryGrouping1 = ''
          if (rule.auxiliaryGrouping2 === 0) rule.auxiliaryGrouping2 = ''
          if (rule.auxiliaryGrouping3 === 0) rule.auxiliaryGrouping3 = ''
          if (rule.auxiliaryGrouping4 === 0) rule.auxiliaryGrouping4 = ''
          if (rule.auxiliaryGrouping5 === 0) rule.auxiliaryGrouping5 = ''
          if (rule.auxiliaryGrouping6 === 0) rule.auxiliaryGrouping6 = ''
          if (rule.groupingDimension1 === 0) rule.groupingDimension1 = ''
          if (rule.groupingDimension2 === 0) rule.groupingDimension2 = ''
          if (rule.groupingDimension3 === 0) rule.groupingDimension3 = ''
          if (rule.groupingDimension4 === 0) rule.groupingDimension4 = ''
          if (rule.groupingDimension5 === 0) rule.groupingDimension5 = ''
          if (rule.groupingDimension6 === 0) rule.groupingDimension6 = ''
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
